import React, { useState } from 'react';
import { CopyIcon, EditIcon, RefreshCwIcon, CheckIcon, SaveIcon } from 'lucide-react';
interface MessageCardProps {
  message: {
    id: number;
    personId: number;
    postId: number;
    subject: string;
    message: string;
  };
  isSelected?: boolean;
  onSave?: (messageId: number, message: string) => void;
  onSelect?: () => void;
}
export const MessageCard: React.FC<MessageCardProps> = ({
  message,
  isSelected = false,
  onSave,
  onSelect
}) => {
  const [copied, setCopied] = useState(false);
  const [editing, setEditing] = useState(false);
  const [editedMessage, setEditedMessage] = useState(message.message);
  const [editedSubject, setEditedSubject] = useState(message.subject);
  const handleCopy = () => {
    navigator.clipboard.writeText(editedMessage);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const handleEdit = () => {
    setEditing(true);
  };
  const handleSave = () => {
    setEditing(false);
    if (onSave) {
      onSave(message.id, editedMessage);
    }
  };
  const handleRegenerate = () => {
    // In a real app, this would call an API to regenerate the message
    // For now, we'll just simulate a delay and keep the same message
    setTimeout(() => {
      console.log('Message regenerated');
    }, 1000);
  };
  const handleClick = () => {
    if (onSelect && !editing) {
      onSelect();
    }
  };
  return <div className={`bg-white rounded-lg shadow-sm border p-4 mb-4 transition-all ${isSelected ? 'border-[#f9b30f] ring-2 ring-[#f9b30f] ring-opacity-50' : 'border-gray-200 hover:border-gray-300'} ${onSelect && !editing ? 'cursor-pointer' : ''}`} onClick={handleClick} data-id="element-537">
      <div className="mb-3" data-id="element-538">
        {editing ? <input type="text" value={editedSubject} onChange={e => setEditedSubject(e.target.value)} className="w-full border border-gray-300 rounded-md p-2 text-sm font-medium text-gray-900" data-id="element-539" /> : <div className="font-medium text-gray-900 text-lg flex items-center" data-id="element-540">
            {editedSubject}
            {isSelected && <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-[#f9b30f] text-white" data-id="element-541">
                <CheckIcon size={12} className="mr-1" data-id="element-542" />
                Selected
              </span>}
          </div>}
      </div>
      {editing ? <div className="mb-4" data-id="element-543">
          <textarea value={editedMessage} onChange={e => setEditedMessage(e.target.value)} className="w-full border border-gray-300 rounded-md p-2 text-sm text-gray-800 min-h-[200px]" data-id="element-544" />
        </div> : <div className="mb-4 whitespace-pre-wrap text-sm text-gray-800 bg-gray-50 p-3 rounded-md" data-id="element-545">
          {editedMessage}
        </div>}
      <div className="flex justify-end space-x-2 pt-2" data-id="element-546">
        <button onClick={e => {
        e.stopPropagation();
        handleRegenerate();
      }} className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-547">
          <RefreshCwIcon size={14} className="mr-1" data-id="element-548" />
          Regenerate
        </button>
        <button onClick={e => {
        e.stopPropagation();
        editing ? handleSave() : handleEdit();
      }} className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-549">
          {editing ? <>
              <SaveIcon size={14} className="mr-1" data-id="element-550" />
              Save
            </> : <>
              <EditIcon size={14} className="mr-1" data-id="element-551" />
              Edit
            </>}
        </button>
        <button onClick={e => {
        e.stopPropagation();
        handleCopy();
      }} className={`inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm leading-4 font-medium rounded-md ${copied ? 'text-green-700 bg-green-50 border-green-200' : 'text-gray-700 bg-white hover:bg-gray-50'}`} data-id="element-552">
          {copied ? <>
              <CheckIcon size={14} className="mr-1" data-id="element-553" />
              Copied!
            </> : <>
              <CopyIcon size={14} className="mr-1" data-id="element-554" />
              Copy
            </>}
        </button>
      </div>
    </div>;
};